import React from "react";
import "./PlantationOneSeparator.scss";
import { useNavigate } from "react-router-dom";

const PlantationSeparator = ({ type = 1 }) => {
  const navigate = useNavigate();

  const designs = {
    1: {
      bgImage:
        "/assets/img/greenify/1.webp",
      quote: "A tree today, a better tomorrow.",
      icon: "🌳",
      author: "- Ralph Waldo Emerson",
    },
    2: {
      bgImage:
       "/assets/img/greenify/2.webp",
      quote: "Plant trees to let your soul breathe",
      icon: "🍃",
      author: "- Anonymous",
    },
    3: {
      bgImage:
        "/assets/img/greenify/1.webp",
      quote: "Grow trees, grow life.",
      icon: "🌲",
      author: "- Matshona Dhliwayo",
    },
    4: {
      bgImage:
           "/assets/img/greenify/5.webp",
      quote: "Let's make Earth green again",
      icon: "🌴",
      author: "- Nelson Henderson",
    },
  };

  const { bgImage, quote, icon, author } = designs[type];

  const handleAdoptTreeClick = () => {
    navigate("/products-two");
  };

  return (
    <div
      className="plantation-separator"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="overlay"></div>
      <div className="content">
        <div className="quote-container">
          <blockquote className="quote-text">"{quote}"</blockquote>
        </div>
        <button className="action-button" onClick={handleAdoptTreeClick}>
          Adopt a Tree
          <span className="button-icon">🌱</span>
          <span className="button-effect"></span>
        </button>
      </div>
    </div>
  );
};

export default PlantationSeparator;
